export default "/static/media/7e53111a6da1927494073de23ebab2f1.png";